var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:_vm.buttonCssClass,on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.isShowIcon)?_c('div',{staticClass:"game-filter-button__icon"},[_c('Icon',{attrs:{"name":_vm.icon,"group":"minigames"}})],1):_vm._e(),_c('span',{staticClass:"game-filter-button__title"},[_vm._v(" "+_vm._s(_vm.title)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }